import {useEffect} from 'react';

interface PropsType {
    ref: React.RefObject<HTMLElement>,
    callback: any,
    options?: IntersectionObserverInit
}

export default function useInfiniteScroll(props: PropsType) {
    const {
        ref,
        callback,
        options = {
            rootMargin: '0px',
            threshold: 1.0
        }
    } = props

    useEffect(() => {
        // IntersectionObserver 생성
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    callback();  // 요소가 뷰포트에 들어오면 콜백 실행
                }
            });
        }, options);

        // ref.current가 유효하면 observer 시작
        if (ref.current) {
            observer.observe(ref.current);
        }

        // Cleanup: 컴포넌트가 언마운트될 때 observer 해제
        return () => {
            if (ref.current) {
                observer.unobserve(ref.current);
            }
        };
    }, [ref, callback, options]);
}
